import { useEffect } from "react";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import EbayOrdersTable from "../../components/ebayOrders/EbayOrdersTable";
import EbayOrdersStats from "../../components/ebayOrders/EbayOrdersStats";


export default function EbayOrders() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "Orders",
      desc: "View and manage sold parts",
    });
  }, []);

  return (
      <>
        <EbayOrdersStats />
        <EbayOrdersTable />
      </>
  );
}
